import {Component, OnInit, Input, OnChanges, SimpleChange} from '@angular/core';

declare var  QRCode: any;

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css']
})
export class QrcodeComponent implements OnInit, OnChanges {

  @Input('code') code: string;
  private qrcode: any;

  constructor() {
  }

  ngOnInit() {
    this.generateQRCode();
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    this.generateQRCode();
  }

  generateQRCode() {
    console.log("generate QR code");
    if (!this.code || this.code.length == 0) {
      console.error("Can't generate qrcode from empty code!", this.code);
      return;
    }
    if (!this.qrcode) {
      let element = document.getElementById("qrcode");
      if (!element) {
        console.error("no qrcode element!");
        return;
      }
      this.qrcode = new QRCode(element, this.code);
    }
    else {
      this.qrcode.makeCode(this.code);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/qrcode/qrcode.component.ts